/**
 * Only organisations the client has publicly named as partners appear here.
 * Logos are NOT bundled: written permission to reproduce each partner mark is
 * required first (see CONTENT_CONFIRMATION.md). Until then partners are shown
 * as named, linked text, accurate, and safe from implying endorsement.
 */
export type Partner = {
  name: string;
  role: string;
  href: string;
  /** Set true only once the client confirms written permission for the mark. */
  logoApproved: boolean;
};

export const partners: Partner[] = [
  {
    name: "The Nestling Trust UK",
    role: "Partner for the Sarangkot Nestling Home and Empowering with Dignity",
    href: "https://www.nestlingtrust.co.uk/",
    logoApproved: false,
  },
  {
    name: "Mountain Routes",
    role: "Charity Trek delivery partner",
    href: "https://mountainroutes.com/",
    logoApproved: false,
  },
];
